// Local dev: leave REACT_APP_API_BASE_URL unset and use package.json "proxy" → /s1 → localhost:8082
const API_CONFIG = {
  BASE_URL: (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, ""),
  REQUEST: {
    TIMEOUT: 10000,
  },
};

export default API_CONFIG;
